import { useState, useCallback } from "react";

const STORAGE_KEY = "doerjun_product_images";

const loadImages = (): Record<string, string> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const saveImages = (images: Record<string, string>) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(images));
};

export const useProductImages = () => {
  const [overrides, setOverrides] = useState<Record<string, string>>(loadImages);

  const getImage = useCallback(
    (productId: string, fallback: string) => overrides[productId] ?? fallback,
    [overrides]
  );

  const setImage = useCallback((productId: string, url: string) => {
    setOverrides((prev) => {
      const next = { ...prev, [productId]: url };
      saveImages(next);
      return next;
    });
  }, []);

  const resetImage = useCallback((productId: string) => {
    setOverrides((prev) => {
      const next = { ...prev };
      delete next[productId];
      saveImages(next);
      return next;
    });
  }, []);

  return { getImage, setImage, resetImage };
};
